import { Component, input, output, signal } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderSectionComponent {
  areItemsCollapsed = signal<boolean>(false);
  selectedFiltersCount = input<number>(0);
  showSelectAll = input<boolean>(true);
  areAllSelected = input<boolean>(false);

  onSelectAll = output<void>();
  onCollapseItemsToggle = output<boolean>();
  onShowFilter = output<void>();
  onAddItem = output<void>();

  onCollapseItemsToggleClick(): void {
    this.areItemsCollapsed.set(!this.areItemsCollapsed());
    this.onCollapseItemsToggle.emit(this.areItemsCollapsed());
  }
}